import { lifecycle, withProps } from 'recompose';

export const withScrollEventListener = lifecycle({
  componentDidMount() {
    this.onScroll = this.props.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
  },
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }
});

export const withOnScroll = (onScroll) =>
  withProps(
    (props) => ({
      onScroll: () => {
        onScroll(props);
        props.onScroll && props.onScroll(props);
      }
    })
  );



// WEBPACK FOOTER //
// ./src/components/higher-order/with-scroll.js